import { type ComponentProps } from "react";
import styled from "styled-components";
import { theme } from "../styles/appTheme";

type AppHeaderProps = {
  logoSrc: string;
  logoAlt: string;
  logoWidth: number;
  copy?: string;
  onLogoError?: ComponentProps<"img">["onError"];
};

export default function AppHeader({
  logoSrc,
  logoAlt,
  logoWidth,
  copy,
  onLogoError,
}: AppHeaderProps) {
  return (
    <AppHeaderRoot>
      <AppHeaderLogo src={logoSrc} alt={logoAlt} $width={logoWidth} onError={onLogoError} />
      {copy ? <AppHeaderCopy>{copy}</AppHeaderCopy> : null}
    </AppHeaderRoot>
  );
}

const AppHeaderRoot = styled.header({
  position: "sticky",
  top: 0,
  zIndex: 20,
  height: 56,
  padding: "10px 12px",
  borderBottom: `1px solid ${theme.palette.divider}`,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  background: theme.palette.white,
});

const AppHeaderLogo = styled.img<{ $width: number }>(({ $width }) => ({
  display: "block",
  width: $width,
  height: "auto",
}));

const AppHeaderCopy = styled.p({
  margin: 0,
  width: 148,
  fontSize: 12,
  fontWeight: 500,
  color: theme.palette.gray,
  textAlign: "right",
  flex: "0 0 148px",
});
